import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import * as firebase from 'firebase/app';
import 'firebase/storage';

@Injectable()
export class DatabaseService {

  private streamsRef: any;
  private mediatorsRef: any;

  constructor(public afDatabase: AngularFireDatabase) {
    this.streamsRef = this.afDatabase.database.ref('streams');
    this.mediatorsRef = this.afDatabase.database.ref('mediators');
  }

  addStream(sInfo) {
    this.streamsRef.push(sInfo);
  }

  getStreams() {
    return this.streamsRef.orderByKey();
  }

  addMediator(mInfo) {
    console.log("addMediator: " + mInfo);
    let storageRef = firebase.storage().ref();
    let uploadTask: firebase.storage.UploadTask;
    uploadTask = storageRef.child('uploads/' + mInfo.schemaFile.name).put(mInfo.schemaFile);
    uploadTask.on('state_changed',
      (snapshot: firebase.storage.UploadTaskSnapshot) => {
        // upload in progress
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + snapshot.state + ": " + progress + '% done');
        // console.log('addMediator(): ', snapshot);
      },
      (error) => {
        // upload failed
        console.log(error)
      },
      () => {
        // upload success
        console.log('upload complete: ' + uploadTask.snapshot.downloadURL);
        mInfo.schemaFile = uploadTask.snapshot.downloadURL;
        this.mediatorsRef.push(mInfo);
      }
    );
  }

  getMediators() {
    return this.mediatorsRef.orderByKey();
  }

}



// WEBPACK FOOTER //
// /var/www/html/mediate/src/app/providers/database.service.ts